import { render } from "./ServiceCategories.vue?vue&type=template&id=429afe65&scoped=true"
import script from "./ServiceCategories.vue?vue&type=script&lang=js"
export * from "./ServiceCategories.vue?vue&type=script&lang=js"

import "./ServiceCategories.vue?vue&type=style&index=0&id=429afe65&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-429afe65"]])

export default __exports__